import { ICampaignServiceState } from "./model"

export const state: ICampaignServiceState = {
  campaignNameById: {}
}
